import { IValidation } from '@vfde-brix/ws10/validation';
import {
    getInvalidCharsValidation,
    getMaxLengthValidation,
    getRequiredValidation,
    INPUT_LENGTH_10,
} from '../../util/validator';

export const CITY_VALIDATIONS: IValidation[] = [
    getRequiredValidation('requiredCity'),
    getMaxLengthValidation(),
    getInvalidCharsValidation(),
];

export const STREET_VALIDATIONS: IValidation[] = [
    getRequiredValidation('requiredStreet'),
    getMaxLengthValidation(),
    getInvalidCharsValidation(),
];

export const HOUSENUMBER_VALIDATIONS: IValidation[] = [
    getRequiredValidation('requiredNumber'),
    getMaxLengthValidation(INPUT_LENGTH_10, 'maxLength10'),
    getInvalidCharsValidation(),
];
